import { Box, ListItem, useTheme } from '@mui/material';

import usePrimaryNavStore from '@/components/shared/PrimaryNavDrawer/PrimaryNavStore';

import PrimaryNavLock from './PrimaryNavLock/PrimaryNavLock';

type PrimaryNavLogoProps = {
  largeLogoPath: string;
  smallLogoPath: string;
};

const PrimaryNavLogo = ({
  largeLogoPath,
  smallLogoPath,
}: PrimaryNavLogoProps) => {
  const { isDrawerOpen } = usePrimaryNavStore();
  const theme = useTheme();

  return (
    <ListItem
      sx={{
        p: isDrawerOpen ? '10px 20px' : 0,
        height: '56px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          transition: `
            opacity 300ms ${theme.transitions.easing.sharp},
            transform 300ms ${theme.transitions.easing.sharp}
          `,
          opacity: isDrawerOpen ? 0 : 1,
          transform: isDrawerOpen
            ? 'translateX(50px) scale(0.25)'
            : 'translateX(0) scale(1)',
          transformOrigin: 'center',
          width: '52px',
          height: '32px',
          mt: 1,
          mx: '5px',
        }}
      >
        <img src={smallLogoPath} alt="logo-small" width="100%" height="100%" />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          transition: `
            opacity 100ms ${theme.transitions.easing.sharp},
            transform 100ms ${theme.transitions.easing.sharp}
          `,
          opacity: isDrawerOpen ? 1 : 0,
          transform: isDrawerOpen
            ? 'translateX(0) scale(1)'
            : 'translateX(0) scale(0.25)',
          transformOrigin: 'center',
          width: '210px',
          height: 'auto',
          mt: 0.5,
          ml: isDrawerOpen ? undefined : '20px',
        }}
      >
        <img src={largeLogoPath} alt="logo-large" width="100%" />
      </Box>

      <PrimaryNavLock />
    </ListItem>
  );
};

export default PrimaryNavLogo;
